// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3CdL0","footer":"Form_footer__2wY8-"};